import config from '@plone/registry';

import styles from '@redturtle/qubicaamf-theme/components/Blocks/Banner/styles.module.css';
import Banner from '@redturtle/qubicaamf-theme/components/Blocks/commons/Banner';
import type { ImageBannerData } from './schema';

interface BannerProps {
  data: ImageBannerData;
  editMode?: boolean;
}

const ImageBanner = (props: BannerProps) => {
  const { data, editMode } = props;
  const Image = config.getComponent('Image').component;
  return (
    <Banner
      data={data}
      editMode={editMode}
      mediaContainerClassname={styles.bannerImageContainer}
    >
      <Image
        item={data.bannerImage}
        className={styles.bannerImage}
        alt={data.bannerImage?.title ?? ''}
      />
    </Banner>
  );
};

export default ImageBanner;
